class SLVConfigController {
  constructor($scope, $log, $rootScope, toastr, VideoService, Business, ngDialog) {
    'ngInject';

    Object.assign(this, {
      $scope,
      $log,
      $rootScope,
      ngDialog,
      toastr,
      VideoService,
      Business
    });
    this.slvON = false; //this.slvOFF = false;

    if (!this.status) {
      Business.getSchedule().then(({
        data
      }) => {
        this.status = data.status;
      });
    }

    Business.getSlvSchedule().then(({
      data
    }) => {
      this.slvStatus = data;
      this.slvStatus.forEach(slvStat => {
        if (slvStat.slv_enabled === 1) slvStat.show_toggle_off = false;else slvStat.show_toggle_off = true;
      });
    });
  }

  confirm() {
    const config = {
      template: 'app/components/modals/confirm.tpl.html',
      data: {
        title: 'Confirm SLV Changes',
        content: 'Are you sure you want to change the SLV settings?'
      }
    };
    this.ngDialog.openConfirm(config).then(() => this.save()).catch(() => {
      this.status.SLV_BUSY = !this.status.SLV_BUSY;
    });
  }

  confirmSLV(slvStatus, slvState) {
    var this2 = this;
    const config = {
      template: 'app/components/modals/confirm.tpl.html',
      data: {
        title: 'Confirm SLV Changes',
        content: 'Are you sure you want to change the SLV settings?'
      }
    };
    this.ngDialog.openConfirm(config).then(() => {
      this.saveSLV(slvStatus, slvState);
    }) // .catch(() => { this.status.SLV_BUSY = !this.status.SLV_BUSY; });
    .catch(() => {
      this.saveUpdateSLV();
    });
  }

  save() {
    this.VideoService.update(this.status).then(() => {
      this.toastr.success('SLV status updated.');
      this.$rootScope.$broadcast('business:slv-status-updated', this.status);
    });
  }

  saveSLV(slvStatus, slvState) {
    this.VideoService.updateSlv(slvStatus, slvState).then(() => {
      this.toastr.success('SLV status updated.');
      this.$rootScope.$broadcast('business:slv-status-updated', this.status);
      this.saveUpdateSLV();
    });
  }

  saveUpdateSLV() {
    var this2 = this;
    this.Business.getSlvSchedule().then(({
      data
    }) => {
      this2.slvStatus = data;
      this2.slvStatus.forEach(slvStat => {
        if (slvStat.slv_enabled === 1) slvStat.show_toggle_off = false;else slvStat.show_toggle_off = true;
      });
    });
  }

}

SLVConfigController.$inject = ["$scope", "$log", "$rootScope", "toastr", "VideoService", "Business", "ngDialog"];
angular.module('pims').controller('SLVConfigController', SLVConfigController);
